var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechicalEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.46C26.65 21.46 31.25 16.86 31.25 11.21C31.25 5.55996 26.65 0.959961 21 0.959961C15.35 0.959961 10.75 5.55996 10.75 11.21C10.75 16.87 15.35 21.46 21 21.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 44.52C20.3699 44.52 19.8499 45.03 19.8499 45.67C19.8499 46.3 20.3599 46.82 20.9999 46.82C21.6299 46.82 22.1499 46.31 22.1499 45.67C22.1499 45.03 21.6299 44.52 20.9999 44.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4301 29.0799C33.4301 25.9599 30.8901 23.4199 27.7701 23.4199H14.2301C11.1101 23.4199 8.57007 25.9599 8.57007 29.0799V34.5799H33.4301V29.0799Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4 37.1201C40.96 36.6201 40.32 36.3301 39.66 36.3301H2.34996C1.67996 36.3301 1.04996 36.6201 0.609957 37.1201C0.169957 37.6201 -0.0300426 38.2901 0.0599574 38.9501L2.22996 55.0101H39.78L41.95 38.9501C42.04 38.2901 41.84 37.6201 41.4 37.1201ZM21 48.5601C19.4 48.5601 18.1 47.2601 18.1 45.6601C18.1 44.0601 19.4 42.7601 21 42.7601C22.6 42.7601 23.9 44.0601 23.9 45.6601C23.9 47.2601 22.6 48.5601 21 48.5601Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechicalEmployee);
export default __webpack_public_path__ + "static/media/techical_employee.03bbfc7850dce11d879eb21607babca6.svg";
export { ForwardRef as ReactComponent };